import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import useAuthStore from '../store/authStore';
import { describeEligibility } from '../services/studentEligibilityService';

/**
 * Year-based feature eligibility for the signed-in user.
 *
 * The auth store keeps `academicProfile` beside `user` rather than on it, so
 * this hook recombines them before asking the service. Components should use
 * this rather than reading years or roll numbers themselves.
 *
 * @returns {{ currentYear: number|null, placementHub: boolean, projects: boolean }}
 */
export default function useStudentEligibility() {
  const { user } = useAuth();
  const academicProfile = useAuthStore((s) => s.academicProfile);

  return useMemo(
    () => describeEligibility(user ? { ...user, academicProfile } : null),
    [user, academicProfile],
  );
}
